var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "section",
    { staticClass: "sendAuthCodeSection", class: { isPc: !_vm.isSp } },
    [
      _c("TitleText", { attrs: { text: "メールアドレス認証" } }),
      _vm._v(" "),
      _c("TextGeneral", { staticClass: "text" }, [
        _vm._v(
          "本人確認のためご入力のメールアドレスに認証コードをお送りいたします。"
        ),
      ]),
      _vm._v(" "),
      _c("InputAreaWithValidation", {
        staticClass: "inputMailAddress",
        attrs: {
          "area-label": "メールアドレス",
          "input-type": "text",
          placeholder: "メールアドレスを入力",
          "validation-list": [
            _vm.VALIDATION_LIST.EMPTY,
            _vm.VALIDATION_LIST.EMAIL,
          ],
        },
        on: { watchValidation: _vm.watchMailAddressValidation },
        model: {
          value: _vm.inputMailAddress,
          callback: function ($$v) {
            _vm.inputMailAddress = $$v
          },
          expression: "inputMailAddress",
        },
      }),
      _vm._v(" "),
      _c("ServerErrorArea", {
        staticClass: "serverErrorArea",
        attrs: {
          "error-type": _vm.errorType,
          "server-error-list": _vm.serverErrorList,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "termsAndPolicyWrapper" }, [
        _c(
          "div",
          { staticClass: "termsAndPolicy" },
          [
            _c("TermsAndPolicy", { attrs: { "is-sp-flg": true } }),
            _vm._v(" "),
            _c("p", [_vm._v("に")]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("ButtonTypeCustom", {
        staticClass: "sendMailButton",
        class: { isDisabled: !_vm.canSendRequest },
        attrs: {
          "button-type": "button",
          "button-text": "同意して認証コードを送信する",
          "button-color": "colorPrimary",
          "button-size": "sizeLarge",
        },
        on: { "button-clicked": _vm.sendMail },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }